import axios from '@axios'
import config from '@core/app-config/api-config'

const base = `${config.host}/settings`

/** Runtime settings by category; types, limits and defaults come from the backend (settings.registry) */
const settingsApi = {
  getCategories() {
    return axios.get(`${base}/categories`)
  },
  getCategory(category) {
    return axios.get(base, { params: { category } })
  },
  update(key, value) {
    return axios.put(`${base}/${encodeURIComponent(key)}`, { value })
  },
  reset(key) {
    return axios.delete(`${base}/${encodeURIComponent(key)}`)
  },
}

export default settingsApi
